export default "__VITE_ASSET__21Ctcvxf__"